import { RouteConfig } from "vue-router";

export const REmployeeCompany: RouteConfig = {
  path: "company",
  name: "EmployeeCompany",
  component: () =>
    import(
      /* webpackChunkName: "employee-company" */
      "./VEmployeeCompany.vue"
    ),
  meta: {
    title: "Company Info",
    icon: "business-outline",
    newIcon: "building-community",
  },
};
